(function () {
  if (window.__ssMegaMenu) return;
  window.__ssMegaMenu = true;

  class MegaMenu {
    constructor(root) {
      this.root = root;
      this.panels = Array.from(root.querySelectorAll('ss-mega-panel'));
      if (!this.panels.length) return;

      this.scrim = root.querySelector('[data-ss-mm-scrim]');
      this.delay = Number(root.dataset.closeDelay) || 180;
      this.byClick = root.dataset.trigger === 'click';
      this.mq = window.matchMedia(`(min-width: ${Number(root.dataset.breakpoint) || 981}px)`);

      this.pairs = [];
      this.current = null;

      this.bind();
      this.mq.addEventListener('change', () => { if (!this.mq.matches) this.close(); });

        document.addEventListener('keydown', (e) => {
        if (e.key !== 'Escape' || !this.current) return;
        const first = this.current.triggers[0];
        this.close();
        first?.focus();
      });

      this.scrim?.addEventListener('click', () => this.close());
      root.dataset.ready = 'true';
    }

    /* --- Association panneau ↔ entrée de menu --- */
        bind() {
      const nav =
        document.querySelector('#header-component') ||
        document.querySelector('header-component') ||
        document.querySelector('#header-group') ||
        document.body;

      const links = Array.from(nav.querySelectorAll('a[href]'));
      const debug = !!window.Shopify?.designMode;

      const normalize = (v) => (v || '')
        .trim()
        .toLowerCase()
        .replace(/^https?:\/\/[^/]+/, '')
        .replace(/[?#].*$/, '')
        .replace(/\/+$/, '');

      this.panels.forEach((panel) => {
        const href = normalize(panel.dataset.ssMmHref);
        const label = (panel.dataset.ssMmLabel || '').trim().toLowerCase();

        let triggers = [];

        // Libellé en priorité : les entrées en « # » ne sont distinguables que par lui
        if (label) {
          triggers = links.filter((a) => a.textContent.trim().toLowerCase() === label);
        }

        // URL en repli, et seulement si elle est exploitable
        if (!triggers.length && href && href !== '' && href !== '#') {
          triggers = links.filter((a) => normalize(a.getAttribute('href')) === href);
        }

        if (!triggers.length) {
          if (debug) console.warn('SS — mega menu : aucune entrée pour', { href, label });
          return;
        }

        if (debug) console.info('SS — mega menu :', triggers.length, 'déclencheur(s) pour', label || href);

        const pair = { panel, triggers, blockId: panel.dataset.ssMmBlock };
        this.pairs.push(pair);

        triggers.forEach((trigger) => {
          trigger.setAttribute('aria-expanded', 'false');
          trigger.setAttribute('aria-controls', panel.id);

          if (this.byClick) {
            trigger.addEventListener('click', (e) => {
              if (!this.mq.matches) return;
              e.preventDefault();
              this.current === pair ? this.close() : this.open(pair);
            });
          } else {
            trigger.addEventListener('mouseenter', () => this.open(pair));
            trigger.addEventListener('mouseleave', () => this.scheduleClose());
          }

          trigger.addEventListener('focus', () => this.open(pair));
        });

        panel.addEventListener('mouseenter', () => this.cancelClose());
        panel.addEventListener('mouseleave', () => this.scheduleClose());
        panel.addEventListener('focusin', () => this.cancelClose());
        panel.addEventListener('focusout', (e) => {
          if (!panel.contains(e.relatedTarget) && !triggers.includes(e.relatedTarget)) {
            this.scheduleClose();
          }
        });

        if (this.byClick) {
          document.addEventListener('click', (e) => {
            if (this.current !== pair) return;
            if (!panel.contains(e.target) && !triggers.some((t) => t.contains(e.target))) {
              this.close();
            }
          });
        }
      });
    }

    open(pair) {
      if (!this.mq.matches) return;
      this.cancelClose();
      if (this.current === pair) return;

      if (this.current) this.setState(this.current, false);
      this.current = pair;
      this.setState(pair, true);
      this.scrim?.classList.add('is-open');
    }

    scheduleClose() {
      this.cancelClose();
      this.timer = setTimeout(() => this.close(), this.delay);
    }

    cancelClose() {
      clearTimeout(this.timer);
      this.timer = null;
    }

    close() {
      this.cancelClose();
      if (!this.current) return;
      this.setState(this.current, false);
      this.current = null;
      this.scrim?.classList.remove('is-open');
    }

    setState({ panel, triggers }, open) {
      panel.classList.toggle('is-open', open);
      triggers.forEach((t) => {
        t.classList.toggle('ss-mm-trigger-open', open);
        t.setAttribute('aria-expanded', String(open));
      });
    }

    /* --- Éditeur : ouvrir le panneau sélectionné --- */
    selectBlock(blockId) {
      const pair = this.pairs.find((p) => p.blockId === blockId);
      if (pair) this.open(pair);
    }
  }

  const instances = [];

  function init() {
    instances.length = 0;
    document.querySelectorAll('[data-ss-mm-root]').forEach((root) => {
      instances.push(new MegaMenu(root));
    });
  }

  function boot() {
    init();
    requestAnimationFrame(() => setTimeout(init, 300));
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (e) => {
    if (e.target.querySelector('[data-ss-mm-root]')) init();
  });

  document.addEventListener('shopify:block:select', (e) => {
    const id = e.target.dataset?.ssMmBlock;
    if (id) instances.forEach((i) => i.selectBlock?.(id));
  });

  document.addEventListener('shopify:block:deselect', () => {
    instances.forEach((i) => i.close?.());
  });
})();